<template>
  <div
    v-if="!!currentManage.type"
    class="layout"
    :class="{ 'layout--no-breadcrumbs': disableBreadcrumbs }"
  >
    <img
      class="layout__q-logo"
      src="/images/logo-small.svg"
    />
    <el-container
      class="layout__container"
      :key="renderContainer"
    >
      <app-menu />

      <el-container class="layout__scroll">
        <el-header
          class="layout__header"
          height
        >
          <app-header />
        </el-header>

        <el-main
          class="layout__main"
          :class="{ 'layout__main--loading': currentManageLoading }"
          v-loading="currentManageLoading"
        >
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ProgressBar from '@shared/progress-bar/progress-bar';

export default {
  name: 'app-layout',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const isRootScreen = !from.name && !from.matched.length;
      vm.setIsRootScreen(isRootScreen);
    });
  },

  data() {
    return {
      disableBreadcrumbs: true,
      renderContainer: 0,
      propertyGuardRoutes : [
        'subpropertyEdit',
        'iamEdit',
        'iamCoachEdit',
      ],
      subpropertyGuardRoutes : [
        'programEdit',
        'programSubprogramEdit',
        'SubprogramNba',
        'gameEdit',
        'SubprogramRegularSeasonRoundsNew',
        'SubprogramRegularSeasonRoundsEdit',
        'schoolEdit',
        'iamEdit',
        'iamCoachEdit',
        'programSettingsCategoryNew',
        'programSettingsCategoryEdit',
        'SubprogramNbaSchoolTeamNew'
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      currentManageLoading: 'auth/manage/currentManageLoading',
    }),
    // currentManageKey() {
    //   const { currentManage } = this
    //   const { type } = currentManage
    //   const id = type in currentManage
    //     ? currentManage[type].id
    //     : 'unique'
    //   return `layout__container--${type}--${id}`
    // },
  },

  methods: {
    ...mapActions({
      setIsRootScreen: 'layout/setIsRootScreen',
    }),
  },
  watch: {
    'currentManage.type'() {
      ProgressBar.done();
    },
    'currentManage.propertyId'() {
      const { $router, $route } = this;
      this.renderContainer += 1;
      if (this.propertyGuardRoutes.includes($route.name)) {
        return $router.push('/subproperty/list');
      }
    },
    'currentManage.subpropertyId'() {
        const { $router, $route } = this;
        if (this.subpropertyGuardRoutes.includes($route.name)) {
          return $router.push('/program');
        } else {
          this.renderContainer += 1;
        }
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700&display=swap');

@import '~@shared/styles/layout.css';
@import '~@shared/styles/auth.css';
@import '~@shared/styles/form.css';
@import '~@shared/styles/filter.css';
@import '~@shared/styles/errors.css';
@import '~@shared/styles/colors.css';
@import '~@shared/styles/settings.css';
@import '~@shared/styles/table.css';
@import '~@shared/styles/view.css';
@import '~@shared/styles/element-ui.css';
@import '~@shared/styles/icons.css';
@import '~@shared/styles/loading.css';
@import '~@shared/styles/simplebar.css';

@import '~@shared/styles/theme/default.css';

:root {
  --layout-main-padding-vertical: 22px;
  --layout-main-padding-horizontal: 40px;
  --layout-main-padding-top: 24px;
  --layout-main-padding-bottom: 40px;
  --layout-main-padding-left: 64px;
  --layout-main-padding-rigth: 40px;
}

.layout--no-breadcrumbs .el-breadcrumb {
  display: none;
}

.layout__container {
  margin: 0;
  padding: 0;
  height: 100vh;
  max-height: 100vh;
}

.layout__header.el-header {
  padding: 0;
  min-height: 80px;
}

.layout__scroll {
  overflow: auto;
  position: relative;
}

.layout__main.el-main {
  overflow: initial;
  padding: var(--layout-main-padding-top) var(--layout-main-padding-rigth) var(--layout-main-padding-bottom) var(--layout-main-padding-left);  
}

.layout__main--loading.el-main{
  overflow: hidden;
}

.layout__q-logo {
  position: fixed;
  width: 435px;
  height: auto;
  top: 100%;
  left: 100%;
  transform: translate(-50%, -50%);
  opacity: .1;
  z-index: 0;
}
</style>
